<template>
  <div class="container">
    <el-row>
      <el-col>
        <!-- <div class="message_content"> -->
        <div>
          <!--判断为空-->
          <div class="emptyDataCenter" v-if="list_data.length == 0">
            <emptyData></emptyData>
          </div>
          <div v-if="list_data.length != 0">
            <el-button @click="AllRead()">全部已读</el-button>
            <div class="msg-list">
              <div class="msg-list-item" v-for="item in list_data" :key="item.index" style="margin-bottom:10px">
                <el-card shadow="hover" class="message_content">
                  <div class="msg_warpper select-head" @click="detailHandle(item)">
                    <div class="msg_icon">
                      <img v-if="item.readFlag == 0" src="../../../assets/images/message_select.png" alt />
                      <img v-if="item.readFlag == 1" src="../../../assets/images/message.png" alt />
                    </div>
                    <div class="msg">
                      <span class="msg_title">
                        <span :class="{ msg_title_read: isread(item.readFlag) }" v-text="item.titile"></span>
                      </span>
                      <div class="msg_detail">
                        <span class="content" v-text="item.msgContent" :class="{ msg_detail_read: isread(item.readFlag) }"></span>
                      </div>
                      <div class="msg_time">
                        <span class="create_time">
                          <i class="fa fa-clock-o" aria-hidden="true"></i>
                          <span v-text="item.sendTime"></span>
                        </span>
                      </div>
                    </div>

                  </div>
                  <span class="unread_red" v-if="item.readFlag != 1"></span>
                </el-card>
              </div>
            </div>
            <!--分页区-->
            <el-row :gutter="20" v-show="list_data != ''">
              <el-col :span="6" :offset="10">
                <el-pagination @current-change="currentPageChange" :page-size="pageList.size" :current-page="pageList.current" layout="total, prev, pager, next" :total="pageList.total"></el-pagination>
              </el-col>
            </el-row>
          </div>

          <!-- </div> -->
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import emptyData from "@/components/common/emptyData";
import util from "@/utils";
import { messageUpdate, messageAllRead } from "@/api/index.js";
export default {
  data () {
    return {
      list_data: "",
      pageList: "",
      status: "",
      pageSize: 5,
      pageNo: 1,
    };
  },
  components: {
    emptyData: emptyData,
  },
  methods: {
    currentPageChange (val) {
      this.pageNo = val;
      // this.readyList();
    },
    /*
     * 提示信息
     * */
    elementTips: function (type, message) {
      const $t = "";
      this.$message({
        showClose: true,
        message: message,
        type: type,
      });
    },
    /**
     * 初次获取数据
     */
    async readyList () {
      try {
        const params = {
          pageNo: this.pageNo,
          pageSize: this.pageSize,
        };
        let res = await getMessageList(params);
        if (res.success) {
          this.list_data = res.result.data.records;
          this.pageList = res.result.data;
          //设置导航的消息未读状态
          let isRead = res.result.unReadNumber;
          this.$store.dispatch("setMsgRead", isRead);
        } else {
          this.elementTips("error", res.message);
        }
      } catch (error) {
        console.log(error);
      }
    },
    isread (status) {
      if (status == 1) {
        return true;
      } else {
        return false;
      }
    },
    /**
     * 阅读是否处理
     * @param  {[type]} item [description]
     * @return {[type]}      [description]
     */
    async detailHandle (item) {
      try {
        if (item.readFlag == 1) {
          return;
        }
        const params = {
          anntId: item.anntId,
        };
        let res = await messageUpdate(params);
        if (res.success) {
          this.readyList();
        }
      } catch (error) {
        console.log(errors);
      }
    },
    /**
     * 消息全部已读
     * @param  {[type]} item [description]
     * @return {[type]}      [description] 
     */
    async AllRead () {
      try {
        const params = {};
        let res = await messageAllRead(params);
        if (res.success) {
          this.elementTips("success", res.message);
          this.readyList();
        }
      } catch (error) {
        console.log(errors);
      }
    },
  },
  mounted () {
    // this.readyList();
  },
};
</script>
<style scoped>
.el-row {
  min-height: 100%;
}

.el-col-24 {
  min-height: 900px !important;
}

.emptyDataCenter {
  min-height: 900px;
}

.nodata {
  display: flex;
  align-items: center;
  position: relative;
  bottom: 40px;
}
.msg-list{
  position: relative;
  margin-bottom:60px
}

.container {
  min-height: 900px;
  width: 100%;
  margin-left: 20px;
}
.el-button {
  margin: 30px 0 30px 0;
  width: 190px !important;
  height: 50px !important;
}

.message_content {
  line-height: 0.55rem;
  width: 100%;
}
.msg {
  height: 50px;
}

.message_content .card-header-custom span {
  line-height: 30px;
}

.message_content .el-button {
  width: 100px;
}

.message_content .el-card {
  margin-top: 10px;
  font-size: 14px;
  min-height: 4em;
  position: relative;
}

.message_content .footer {
  padding: 18px 20px;
}

.message_content .el-tabs--border-card > .el-tabs__content {
  height: 0;
  padding: 0;
  margin: 0;
}

.message_content .create_time {
  font-size: 11px;
  color: #999;
}

.message_content .main-content .content {
  word-break: break-all;
}

.read_status {
  color: #f39c12;
}

.msg_detail_read {
  color: #a69e9e;
}

.msg_title_read {
  color: #a69e9e;
}

.message_content .msg_warpper {
  display: flex;
  padding: 20px;
}

.message_content .msg_warpper .msg_content {
  text-align: left;
}

.message_content .msg_warpper .msg_icon {
  display: flex;
  align-items: center;
  margin-right: 20px;
  margin-top: 10px;
}
.msg-list-item {
  position: relative;
}
.message_content .unread_red {
  width: 15px;
  height: 15px;
  background: #fe646a;
  display: block;
  border-radius: 50%;
  position: absolute;
  top: 15px;
  right: 15px;
}
.msg_title {
  margin-bottom: 30px;
  margin-top: 30px;
}
.message_content .msg_warpper .msg_title {
  font-size: 16px;
  font-weight: bold;
  color: #f39c12;
}

.message_content .msg_warpper .msg_detail {
  margin: 30px 0;
}

.message_content .msg_warpper .msg_detail .notice_detail {
  font-size: 10px;
  color: #f39c12;
}

.message_content .msg_warpper .msg_icon img {
  width: 48px;
}
/**
	*把user中样式覆盖
	*/
.message_content .el-card__body {
  padding: 20px !important;
}
</style>
